import React from "react";

import ls from './ConfigEditor.less';
import { EditOutlined } from '@ant-design/icons';

export function EditorModeButton({value, onChange}) {

  return <button id={ls.configBtn} onClick={() => onChange(!value)}><EditOutlined style={{color: value && '#f0f' }} /></button>;

}